import axios from 'axios';
import md5 from 'js-md5';
const logRequests = !!process.env.DEBUG_API
// 请求数据
export function Ajax (url, params, type, state) {
    logRequests && console.log(`fetching ${child}...`)
    axios.interceptors.request.use(
        config => {
            const yxDeviceId = frandomName(8);
            config.headers["yx-device-id"] = yxDeviceId;
            config.headers["yx-app-type"] = 4;
            config.headers['yx-smid'] = "";
            const randStr = frandomName(16);
            config.headers["yx-rand-str"] = randStr;
            config.headers["yx-sign"] = creatMd5(yxDeviceId, 4, randStr, '');
            if (typeof window !== 'undefined') {
                let token = JSON.parse(window.localStorage.getItem("token")) 
                if (token) {
                    config.headers.authorization = "Bearer" + token.access_token 
                }
            }
            return config;
        },
        error => {
            return Promise.resolve({})
            // return resolve({});
            // return Promise.reject(error);
        }
    );
    let promise;
    return new Promise((resolve, reject) => {
        if (type === "GET") {
            let paramStr = '';
            for (var item in params) {
                paramStr += item + "=" + params[item] + "&";
            }
            if (paramStr !== '') {
                paramStr = paramStr.substr(0, paramStr.lastIndexOf("&"));
            }
            url = url + "?" + paramStr;
            promise = axios.get(url, params);
        } else if (type === "POST") {
            promise = axios.post(url, params);
        } else if (type === "PUT") {
            promise = axios.put(url, params);
        }
        promise.then((response) => {
            resolve(response.data);
        }).catch((err) => {
            console.log(err)
            resolve({});
            console.log('服务端请求错误', url, '参数' + JSON.stringify(params))
            // reject(err);
        })
    });
}
    // 生成随机长度的字符串
function frandomName (len) {
    len = len || 16;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var charsLength = chars.length;
    var str = '';
    for (let i = 0; i < len; i++) {
        str += chars.charAt(Math.floor(Math.random() * charsLength))
    }
    return new Date().getTime() + str
}
// md5生成签名
function creatMd5 (_deviceId, _appType, _randStr, _yxSmid) {
    const secretKey = "88egqJK97pevbQD0";
    return md5(secretKey + _deviceId + _appType + _randStr + _yxSmid)
}